import { useEffect, useRef } from 'react';
import { useGetEnvironnementQuery } from '@services/configApi';
import { initializeTelemetry } from './telemetry';

/**
 * Component that initializes Application Insights telemetry after
 * fetching the connection string from the backend.
 *
 * Must be placed inside a Redux Provider for RTK Query to work.
 * Renders nothing - just handles the telemetry initialization side effect.
 */
function TelemetryInitializer(): null {
  const { data: environnement } = useGetEnvironnementQuery();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (environnement && !hasInitialized.current) {
      hasInitialized.current = true;
      initializeTelemetry(environnement.applicationInsightsConnectionString);
    }
  }, [environnement]);

  return null;
}

export default TelemetryInitializer;
